import { StackProps } from '@chakra-ui/layout';
import { Stack } from '@chakra-ui/react';
import React from 'react';

export const FixedScreenHeaderStack: React.FC<StackProps> = ({
  children,
  ...props
}) => {
  return (
    <Stack
      position="sticky"
      top={2}
      left={0}
      right={0}
      backgroundColor="white"
      zIndex={10}
      {...props}
    >
      {children}
    </Stack>
  );
};
